import BannerSwiper from "components/home/BannerSwiper";
import Services from "components/home/Services";
import About from "components/home/About";
import OurGroup from "components/home/OurGroup";

export default function Home() {
    return (
        <div className="bg-white">
            <section>
                <BannerSwiper />
            </section>
            <section>
                <About />
            </section>
            <section>
                <Services />
            </section>
            <section>
                <OurGroup />
            </section>
        </div>
    );
}
